export default "__VITE_ASSET__DqjyLxN4__"